import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import * as THREE from 'three';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatLastActive(lastActiveISO?: string) {
  if (!lastActiveISO) return 'nunca logado';
  try {
    const lastActive = new Date(lastActiveISO);
    const now = new Date();
    const diffMs = now.getTime() - lastActive.getTime();
    if (isNaN(diffMs) || diffMs < 0) return 'agora mesmo';
    
    const diffSeconds = Math.floor(diffMs / 1000);
    const diffMinutes = Math.floor(diffSeconds / 60);
    const diffHours = Math.floor(diffMinutes / 60);
    const diffDays = Math.floor(diffHours / 24);
    const diffYears = Math.floor(diffDays / 365);

    if (diffSeconds < 30) {
      return 'online agora';
    } else if (diffSeconds < 60) {
      return 'há menos de 1 minuto';
    } else if (diffMinutes === 1) {
      return 'há 1 minuto';
    } else if (diffMinutes < 60) {
      return `há ${diffMinutes} minutos`;
    } else if (diffHours === 1) {
      return 'há 1 hora';
    } else if (diffHours < 24) {
      return `há ${diffHours} horas`;
    } else if (diffDays === 1) {
      return 'há 1 dia';
    } else if (diffDays < 7) {
      return `há ${diffDays} dias`;
    } else if (diffDays < 30) {
      return `há ${Math.floor(diffDays / 7)} semanas`;
    } else if (diffDays < 365) {
      return `há ${Math.floor(diffDays / 30)} meses`;
    } else if (diffYears === 1) {
      return 'há 1 ano';
    } else {
      return `há ${diffYears} anos`;
    }
  } catch (e) {
    return 'data inválida';
  }
}

const vectorPool: THREE.Vector3[] = [];
let poolIdx = 0;

export function getPooledVector(x: number, y: number, z: number) {
  if (poolIdx >= vectorPool.length) {
    vectorPool.push(new THREE.Vector3());
  }
  const v = vectorPool[poolIdx++];
  v.set(x, y, z);
  return v;
}

export function resetPool() {
  poolIdx = 0;
}
